import kr from '../../kr/kr';
import HTMLClass from '../../kr/utils/HTMLClass';

export default class PointsMap extends kr.Component {
    init() {
        this.app.addJs('https://unpkg.com/leaflet@1.7.1/dist/leaflet.js', true, this._callback.bind(this));
        this.app.addCss('https://unpkg.com/leaflet@1.7.1/dist/leaflet.css');

        this.mapEl = this.$element.querySelector('.js-pointsMapContainer');

        this.items = this.$element.querySelectorAll('.js-pointsItem');
        this.buttons = this.$element.querySelectorAll('.js-pointsMapCats button');
        this.map = null;
        this.mapMarkers = [];
        this.mapMarkersLatLng = [];

        this.catEnabled = {};
    }

    bind() {
        this.map = window.L.map(this.mapEl, {
            center: [53.4866, 18.0198],
            zoom: 13
        });
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(this.map);

        this.reloadItems();

        this._bindEvents();
    }

    _bindEvents()
    {
        this.on('click', '.js-pointsMapCats button', (target, event) => {
            event.preventDefault();
            HTMLClass.toggleClass(target, 'points__cateogires__button--active');
            const key = target.getAttribute('data-slug');
            if (!HTMLClass.hasClass(target, 'points__cateogires__button--active')) {
                delete this.catEnabled[key];
            } else {
                this.catEnabled[key] = 1;
            }
            
            this.items.forEach(item => {
                const slug = item.getAttribute('data-cat');
                if (Object.keys(this.catEnabled).length == 0) {
                    item.parentNode.style.display = "block";
                } else if (typeof this.catEnabled[slug] !== 'undefined') {
                    item.parentNode.style.display = "block";
                } else {
                    item.parentNode.style.display = "none";
                }
            });

            this.reloadItems();
        })
    }

    reloadItems()
    {   
        this._clearMarkers();

        for (let i in this.items) {
            if (!this.items.hasOwnProperty(i)) {
                continue;
            }
        
            const item = this.items[i];
            const slug = item.getAttribute('data-cat');
            if (Object.keys(this.catEnabled).length > 0 && typeof this.catEnabled[slug] === 'undefined') {
                continue;
            }

            this._addMarker(item);
        }
        const bounds = new L.LatLngBounds(this.mapMarkersLatLng);
        this.map.fitBounds(bounds);
    }

    _addMarker(item)
    {
        const lat = item.getAttribute('data-lat');
        const lng = item.getAttribute('data-lng');
        const marker = L.marker([lat, lng]).addTo(this.map);
        const name = item.getAttribute('data-name');
        const cat = item.getAttribute('data-cat-name');
        const href = item.getAttribute('href');
        marker.bindPopup(`
            <div>
                <p class="name">${name}</p>
                <p>${cat}</p>
                <p><a href="${href}" class="button button--small button--blue">Czytaj więcej</a></p>
            </div>
        `)
        this.mapMarkers.push(marker);
        this.mapMarkersLatLng.push([lat, lng]);
    }

    _clearMarkers()
    {
        this.mapMarkers.forEach(item => {
            console.log(item);
            this.map.removeLayer(item);
        });
        this.mapMarkers = [];
        this.mapMarkersLatLng = [];
    }

    _callback()
    {
        this.bind();
    }
}

kr.registerComponent('.js-pointsMap', {
    component: PointsMap
});